// extracted by mini-css-extract-plugin
export default {"ImageContainer":"PhotoEditor_ImageContainer__hNNFr","ImageWrapper":"PhotoEditor_ImageWrapper__bzdUW","ToolsContainer":"PhotoEditor_ToolsContainer__eCZCb"};